import axios from "axios";

export default {
  summary({service, duration, start_date, end_date }) {
    let params = `duration=${duration}`;


    if (start_date, end_date) {
      params += `&start_date=${start_date}&end_date=${end_date}`;
    }

    if (service) {
      params += `&service=${service}`;
    }
    return axios.get(`crm/feedback/stats?${params}`);
  },
  index(params) {
    return axios.get(`crm/feedback?${params}`);
  },
};
